module.exports = __webpack_public_path__ + "img/scenario_02.6861aa32.jpg";